import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable, EMPTY } from "rxjs";
import { AuthService } from "./authServices";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Config must load during APP_INITIALIZER before session state is reconciled.
    if (
      req.url.endsWith("/admin/config") ||
      req.url.endsWith("/config.json") ||
      req.url.includes("/config.json")
    ) {
      return next.handle(req);
    }

    if (this.authService.isSessionExpiredDueToInactivity()) {
      if (!this.authService.getIsAuth()) {
        this.authService.reconcileExpiredSessionAfterRefresh();
        return EMPTY;
      }
      this.authService.showSessionExpiredDialog();
      return EMPTY;
    }

    const authToken = this.authService.getToken();
    const roleName =
      this.authService.getRoleName() ||
      (typeof localStorage !== "undefined"
        ? localStorage.getItem("roleName")
        : null);

    let headers = req.headers;

    if (authToken) {
      headers = headers.set("Authorization", `Bearer ${authToken}`);
    }

    if (roleName) {
      headers = headers.set("RoleName", roleName);
    }

    const lastActivity = this.authService.getLastActivityTimestamp();
    if (lastActivity) {
      headers = headers.set("X-Client-Last-Activity", String(lastActivity));
    }

    const authRequest = req.clone({ headers });

    return next.handle(authRequest);
  }
}
